<template>
  <div class="settingWrapper">
    <el-image
      style="width: 32px; height: 32px"
      src="https://static.zc0901.com/dci-miniapp/close-icon-pc.png"
      class="close"
      @click="jumpHome"
    ></el-image>
    <section class="settingWrapper_dialog">
      <div class="settingWrapper_dialog_top">
        <p class="settingWrapper_dialog_top_Bg"></p>
        <div class="text_des prl4 ptb3">
          <el-image
            style="width: 100px; height: 88px"
            src="https://static.zc0901.com/imola-dci-web-icon.png"
          ></el-image>
          <!-- <p class="text-white h4 prl3 text_des_tip">平行进口，创新科技，意式生活</p> -->
        </div>
      </div>
      <aside class="prl4 modify">
        <div class="modify_password mt3">
          <el-image
            style="width: 20px; height: 16px"
            src="https://static.zc0901.com/dci-miniapp/settingTip-icon.png"
          ></el-image>
          <p class="h3 blod prl1">账号设置</p>
        </div>
        <el-row class="mt4">
          <el-col :span="12" class="text-left">
            <span class>登录密码</span>
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button type="primary" @click="modifyPassword">修改/设置</el-button>
          </el-col>
        </el-row>
        <el-divider class="line"></el-divider>
      </aside>
    </section>
    <aside class="password" v-if="password"></aside>
    <PassWordFind className='passZindex' v-if='password' ref='passColse' @closePass="closePass"></PassWordFind>
  </div>
</template>

<script>
import PassWordFind from "@/components/login/password-find";
export default {
  components: { PassWordFind },
  data() {
    return {
      password: false
    };
  },
  created() {},
  mounted() {},
  methods: {
    closePass(){
      this.password = false;
    },
    jumpHome(){
      this.$router.push('/')
    },
    modifyPassword() {
      this.password = true
    }
  }
};
</script>

<style lang="scss" scoped>
.settingWrapper {
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: rgba(19, 26, 37, 1);
  &_dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 760px;
    height: 500px;
    transform: translate(-50%, -50%);
    &_top {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 152px;
      background: url("https://static.zc0901.com/dci-miniapp/setingBg.png")
        no-repeat;
      background-size: cover;
      &_Bg {
        position: absolute;
        z-index: 3;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background: linear-gradient(
          270deg,
          rgba(0, 0, 0, 0.3) 0%,
          rgba(0, 0, 0, 1) 100%
        );
      }
      .text_des {
        position: absolute;
        z-index: 4;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        &_tip {
          vertical-align: bottom;
        }
      }
    }
  }
}
.modify {
  background: #fff;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  // height: 350px;
  .modify_password {
    display: flex;
    align-items: center;
  }
}
.password {
  width:100%;
  height:100%;
  min-height: 560px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.7;
}
.passZindex {
  z-index: 1003;
  position:absolute;
  left:50%;
  top:50%;
  transform: translate(-50%, -50%);
  background: #fff;
}
.close {
  position: absolute;
  right: 40px;
  top: 40px;
  cursor: pointer;
}
</style>
<style lang="scss">
.line {
  &.el-divider--horizontal {
    margin: 8px 0;
  }
}
</style>
